import * as React from 'react'

import Card        from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Divider     from '@material-ui/core/Divider'
import styled      from 'styled-components'

import { InlineError, LoadingOverlay } from '../atoms'
import { RegistrationStepper }         from '../molecules'

const RegistrationWizardWrapper = styled(Card)`
  height:   100%;
  margin:   auto;

  @media screen and (max-width: 600px) {
    & {
      width: 100%;
      border-radius: 0;
    }
  }
`

export interface InjectedStepperProps {
  onSubmit: (values: object) => void
  goToPrevious: (values: object) => void
  values: any
  isFirstStep: boolean
  isLastStep: boolean
}

export interface FormStep {
  label: string
  form: React.ComponentType<InjectedStepperProps>
}

interface RegisterWizardProps {
  steps: FormStep [],
  done: (values: object) => void
  error?: string
  isSubmitting: boolean
}

interface RegisterWizardState {
  activeStep: number
  values: object
}

export default class extends React.Component<RegisterWizardProps, RegisterWizardState> {
  public state = {
    activeStep: 0,
    values:     {},
  }

  public render () {
    const currentFormStep = this.getCurrentFormByStep()
    const { activeStep } = this.state
    const { steps } = this.props
    return (
      <RegistrationWizardWrapper elevation={8}>
        <LoadingOverlay show={this.props.isSubmitting}>
          <RegistrationStepper
            activeStep={activeStep}
            steps={steps}
          />

          <Divider />

          {this.renderError()}

          {currentFormStep}
        </LoadingOverlay>
      </RegistrationWizardWrapper>
    )
  }

  private renderError = () => {
    if (this.props.error) {
      return (
        <>
          <CardContent>
            <InlineError i18nErrorId={this.props.error} />
          </CardContent>
          <Divider />
        </>
      )
    }

    return null
  }

  private done = () => {
    this.props.done(this.state.values)
  }

  private finish = (values: object) => {
    this.setState(
      state => (
        {
          values: {
            ...state.values,
            ...values,
          },
        }),
      this.done,
    )
  }

  private getCurrentFormByStep = () => {
    const { values, activeStep } = this.state
    const { steps } = this.props
    const isFirstStep = activeStep === 0
    const isLastStep = activeStep === steps.length - 1

    const commonProps = {
      values,
      isFirstStep,
      isLastStep,
      onSubmit:     this.collect,
      goToPrevious: this.goToPrevious,
    }

    if (isLastStep) {
      commonProps.onSubmit = this.finish
    }

    const CurrentForm = steps[ activeStep ].form

    return <CurrentForm {...commonProps} />
  }

  private goToPrevious = (values: object) => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
      values:     {
        ...state.values,
        ...values,
      },
    }))
  }

  private goToNext = () => {
    this.setState(state => ({ activeStep: state.activeStep + 1 }))
  }

  private collect = (values: object) => {
    this.setState(state => ({
      values: {
        ...state.values,
        ...values,
      },
    }))
    this.goToNext()
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/RegistrationWizard.tsx